const LEGACY_PREFIX = '/fleet-management/digital-vehicle-files';
const CURRENT_PREFIX = '/fleet-management/vehicles';

// Prefixed with `-` so the router's file-based route generator skips this file.
export function redirectToVehicles(href: string) {
  return {
    href: href.replace(LEGACY_PREFIX, CURRENT_PREFIX),
    replace: true,
  };
}
